module.exports = "<button-spinner ng-if=!vm.href ng-click=vm.performAction() active=vm.active button-class={{vm.buttonClass}} span-class=hidden-xs state-normal-icon={{vm.icon}} state-normal-text=\"vm.text | translate\"> </button-spinner> <a ng-if=vm.href href={{vm.href}} ng-class=vm.buttonClass> <i ng-class=vm.icon></i> <span class=hidden-xs>{{vm.text | translate}}</span> </a> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-head/cn-head-action/cn-head-action.html
 ** module id = 40
 ** module chunks = 0
 **/